import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledAgendaEventRepeatSchedule = styled(Flexbox)`
    & .agenda-schedule-repeat-select {
        outline: none;
        box-shadow: none;
        padding: 0;

        &:hover {
            box-shadow: none;
            outline: none;
            background-color: transparent;
        }
    }
`

export const StyledWarningSchedulesChanges = styled(Flexbox)(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};

        & > svg {
            color: ${palette.orange[500]};
            width: 15px;
            height: 15px;
        }

        & > p {
            color: ${palette.orange[800]};
        }
    `
)

export const StyledAlertSchedulesChanges = styled(StyledWarningSchedulesChanges)(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};

        & > svg {
            color: ${palette.red[500]};
        }

        & > p {
            color: ${palette.red[800]};
        }
    `
)
